/*
 * ATN Country Intelligence - country comparison
 *
 * Reads a JSON payload rendered by the section, fills the indicator and
 * country dropdowns, and draws a two bar comparison. No charting library is
 * needed: the bars are plain elements sized as a percentage of the larger
 * value.
 *
 * Payload shape:
 *   {
 *     "home": { "name": "Canada", "flag": "...", "values": { "GDP": [2140, "$2.14T"] } },
 *     "countries": [ { "name": "Mexico", "flag": "...", "values": { ... } } ]
 *   }
 */
(function () {
  'use strict';

  if (window.atnCiCompare) return;
  window.atnCiCompare = true;

  function Compare(root) {
    this.root = root;
    var payload = root.querySelector('[data-atn-cmp-data]');
    if (!payload) return;

    try {
      this.data = JSON.parse(payload.textContent);
    } catch (err) {
      return;
    }
    if (!this.data || !this.data.home) return;

    this.indicatorSelect = root.querySelector('[data-atn-cmp-indicator]');
    this.countrySelect = root.querySelector('[data-atn-cmp-country]');
    this.button = root.querySelector('[data-atn-cmp-run]');
    this.chart = root.querySelector('[data-atn-cmp-chart]');
    this.empty = root.querySelector('[data-atn-cmp-empty]');
    if (!this.indicatorSelect || !this.countrySelect || !this.chart) return;

    this.fillIndicators();
    this.fillCountries();

    var self = this;
    if (this.button) {
      this.button.addEventListener('click', function () { self.run(); });
    }
    this.indicatorSelect.addEventListener('change', function () { self.maybeAuto(); });
    this.countrySelect.addEventListener('change', function () { self.maybeAuto(); });

    if (root.getAttribute('data-cmp-auto') === 'true') this.run();
  }

  Compare.prototype.maybeAuto = function () {
    if (this.root.getAttribute('data-cmp-auto') === 'true') this.run();
  };

  Compare.prototype.fillIndicators = function () {
    var keys = Object.keys(this.data.home.values || {});
    var frag = document.createDocumentFragment();
    keys.forEach(function (key) {
      var opt = document.createElement('option');
      opt.value = key;
      opt.textContent = key;
      frag.appendChild(opt);
    });
    this.indicatorSelect.appendChild(frag);
  };

  Compare.prototype.fillCountries = function () {
    var frag = document.createDocumentFragment();
    (this.data.countries || []).forEach(function (country, i) {
      var opt = document.createElement('option');
      opt.value = String(i);
      opt.textContent = country.name;
      frag.appendChild(opt);
    });
    this.countrySelect.appendChild(frag);
  };

  Compare.prototype.run = function () {
    var key = this.indicatorSelect.value;
    var idx = this.countrySelect.value;
    if (!key || idx === '') return;

    var other = (this.data.countries || [])[parseInt(idx, 10)];
    if (!other) return;

    var a = this.data.home.values[key];
    var b = other.values ? other.values[key] : null;

    if (!a && !b) {
      this.showMessage(this.root.getAttribute('data-cmp-nodata') || 'No data for this indicator.');
      return;
    }

    var aNum = a ? Number(a[0]) : 0;
    var bNum = b ? Number(b[0]) : 0;
    var max = Math.max(aNum, bNum) || 1;

    this.chart.innerHTML = '';
    if (this.empty) this.empty.hidden = true;

    this.chart.appendChild(this.buildBar(this.data.home.name, a, aNum, max, 'home'));
    this.chart.appendChild(this.buildBar(other.name, b, bNum, max, 'other'));
  };

  Compare.prototype.buildBar = function (name, entry, num, max, variant) {
    var wrap = document.createElement('div');
    wrap.className = 'atn-ci-cmp__bar atn-ci-cmp__bar--' + variant;

    var value = document.createElement('span');
    value.className = 'atn-ci-cmp__bar-value';
    value.textContent = entry ? entry[1] : '—';

    var track = document.createElement('span');
    track.className = 'atn-ci-cmp__bar-track';

    var fill = document.createElement('span');
    fill.className = 'atn-ci-cmp__bar-fill';
    var pct = max > 0 ? Math.max(2, Math.round((num / max) * 100)) : 2;
    fill.style.height = (entry ? pct : 0) + '%';

    var label = document.createElement('span');
    label.className = 'atn-ci-cmp__bar-label';
    label.textContent = name;

    track.appendChild(fill);
    wrap.appendChild(value);
    wrap.appendChild(track);
    wrap.appendChild(label);
    return wrap;
  };

  Compare.prototype.showMessage = function (text) {
    this.chart.innerHTML = '';
    if (this.empty) {
      this.empty.textContent = text;
      this.empty.hidden = false;
    }
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-atn-cmp]').forEach(function (el) {
      if (el.dataset.cmpReady === '1') return;
      el.dataset.cmpReady = '1';
      new Compare(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();